export default __webpack_public_path__ + "static/media/new.102c04e3.svg";